export default "__VITE_ASSET__BGFcqJLH__"